<template>
	<div class="contentPayDet">
		<van-row v-if="roomData.roomInfo">
			<van-col span="24" class="cardBar">
				<van-row class="InfoCard">
					<van-col span="24" class="cardNumber">卡号：<span class="number">{{ roomData.roomInfo.userCardNumber }}</span></van-col>
					<van-col span="24" class="address">{{roomData.roomInfo.address}}</van-col>
					<van-col span="12" class="name">{{hideCenterName(roomData.roomInfo.userName)}}</van-col>
					<van-col span="12" class="area textR">用热面积：{{roomData.roomInfo.useArea}}</van-col>
					<van-col span="12" class="money">待缴总金额</van-col>
					<van-col span="12" class="money textR"><span>¥ {{roomData.allSumMoney}}</span></van-col>
				</van-row>
			</van-col>
			<van-col span="24">
				<van-row class="billBar" v-for="(itemN,index) in roomData.notpayMoneyResp.details" :key="'yj'+index" v-if="roomData.notpayMoneyResp.details">
					<template v-if="roomData.heatingYear==itemN.heatingYear && showStop && closeVillage">
						<van-col span="24" class="title" style="color: #333;"><i class="icon"></i>采暖季：{{itemN.heatingYear}}<van-button type="warning" @click="stopHot" v-if="roomData.notpayMoneyResp.emptyStatus=='1'">停热</van-button><van-button type="primary
						" @click="recoverHot" v-if="roomData.notpayMoneyResp.emptyStatus=='3'">恢复供热</van-button></van-col>
					</template>
					<template v-else>
						<van-col span="24" class="title" style="color: #333;"><i class="icon"></i>采暖季：{{itemN.heatingYear}}</van-col>
					</template>
					<van-col span="24" class="cont">
						<van-col span="14" class="orange bill-money">采暖季应缴：{{itemN.receiveMoney}}元</van-col>
						<van-col span="10" class="bill-money textR">单价：{{itemN.price}}元</van-col>
						<van-col span="14">退费金额：{{itemN.refundMoney}}元</van-col>
						<van-col span="10" class="textR">优惠：{{itemN.discountMoney}}元</van-col>
						<!-- <van-col span="24" class="bill-money">公式：{{itemN.price}}(单价)*{{roomData.roomInfo.useArea}}(面积)*{{itemN.months}}(月份)</van-col> -->
					</van-col>
				</van-row>
				<van-row class="billBar" style="padding-bottom: 0;" v-for="(itemH,index) in roomData.historyMoneyResp.details" :key="index" v-if="roomData.historyMoneyResp.details">
					<van-col span="24" class="title" style="color: #333;"><i class="icon"></i>采暖季：{{itemH.heatingYear}}</van-col>
					<van-col span="24" class="cont">
						<van-col span="24" class="orange bill-money">违约金费用：{{itemH.money}}元</van-col>
					</van-col>
				</van-row>
			</van-col>
			<van-col span="24" type="flex" justify="space-between" class="barBtn">
				<van-button round type="danger" size="large" class="btn" :disabled="roomData.notpayMoneyResp.sumMoney==0&&roomData.historyMoneyResp.sumMoney==0"
				 @click.prevent="paymentBtn(roomData.canPay)">去缴费</van-button>
			</van-col>
		</van-row>
		<van-row class="noPayBar" v-if="!roomData&&!roomData.roomInfo">
			<van-col span="24" class="noPayPC"></van-col>
			<van-col span="24" class="text1 orange">没有找到该用户！</van-col>
			<van-col span="24" class="text2">去试试【自主信息填写缴费】吧！</van-col>
		</van-row>
		<van-action-sheet v-model="isPayShow" title="确认付款">
			<van-row class="PayPop">
				<van-col span="24" class="money">总缴纳金额（元）</van-col>
				<van-col span="24" class="money"><span class="orange">{{roomData.allSumMoney}}</span></van-col>
				<van-col span="12" class="Ptext1">缴费</van-col>
				<van-col span="12" class="Ptext2 textR">{{roomData.companyName}}</van-col>
				<van-col span="12" class="Ptext1">付款方式</van-col>
				<van-col span="12" class="Ptext2 textR">微信</van-col>
				<van-col span="24" type="flex" justify="space-between" class="barBtn">
					<van-button round type="danger" size="large" class="btn" v-if="isPFPay"  @click.prevent="confirmPFPayment()">确认并付款</van-button>
					<van-button round type="danger" size="large" class="btn" v-else @click.prevent="confirmPayment()">确认并付款</van-button>
				</van-col>
			</van-row>
		</van-action-sheet>
	</div>
</template>

<script>
	import envJS from '../../common/js/env'
	import {
		Toast
	} from 'vant';
	import {
		reqVillage,
		reqNotpayList,
		reqPayType,
		reqPayMethod,
		reqPayOrderAdd,
		reqPFPayOrderAdd,
		reqPFSearch,
		reqPFClear,
		stopHot,
		recoverHot,
		valveRel
	} from '../../api'
	export default {
		name: "paydetail",
		data() {
			return {
				isPayShow: false,
				roomId: '',
				userId: '',
				roomData: {},
				Method: {},
				payTypes: '',
				isPFPay:false,
				companyId:'',
				timeout:'',
				openPay:false,
				showStop:false,
				closeVillage:false
			}
		},
		created() {
			this.userId = this.$cookies.get('userInfo').userId;
			this.roomId = this.$route.query.roomId;
		},
		mounted() {
			this.roomId = this.$route.query.roomId;
			this.isPay = this.$route.query.isPay;
			//暂停缴费
			// Toast.fail({message:'暂未开放缴费！',className:'apiLoading'});
			// return
			/*
			 * 查询房屋应缴记录
			 * */
			let data = {
				roomId: this.roomId
			}
			reqNotpayList(data).then(res => {
				if (res.success) {
					this.roomData = res.data

					// //陕柴二期 暂不开启自动停热
					// if(this.roomData.roomInfo.villageId=='VGORkXy18gxd29lpr5qrMaoEmZ60AqNzw5P'){
					// 	this.closeVillage = false
					// }else{
					// 	this.closeVillage = true
					// }
					// this.valveRel()

					// //判断是否显示浦发支付
					// if(this.roomData.companyId=='D4v1pQBEqaNlLe7wj9Ld9knJgZP5oARy83W'){
					// 	this.isPFPay = true
					// }
					// const param = {
					// 	companyId:this.roomData.companyId,
					// 	villageId:this.roomData.roomInfo.villageId
					// }
					// reqVillage(param).then(re=>{
					// 	console.log(re)
					// 	if(re.data.length==0){
					// 			Toast.fail({
					// 				message:'当前小区未开通在线收费，请咨询热力公司，咨询电话：029-33560219',
					// 				className: 'apiLoading'
					// 			});
					// 			this.openPay = false
					// 			return
					// 	}else{
					// 		this.openPay = true
					// 		if (this.isPay) {
					// 			this.paymentBtn(this.roomData.canPay)
					// 		}
					// 	}
					// })
				} else {
					Toast.fail({
						message: res.msg,
						className: 'apiLoading'
					});
				}
			})
		},
		beforeDestroy() {
			clearTimeout(this.timeout)
		},
		methods: {
			paymentBtn(canPay) {
				if (canPay) {
					this.isPayShow = true
					this.PayType()
				} else {
					Toast.fail({
						message: '请前往缴费大厅缴费！',
						className: 'apiLoading'
					});
				}
			},
			/*
			 *  查询支付类型
			 * */
			PayType() {
				let data = {
					companyId: this.roomData.companyId,
					parentCompanyId: this.roomData.parentCompanyId
				}
				reqPayType(data).then(res => {
					if (res.success) {
						this.PayMethod(res.data[0].id)
					} else {
						Toast.fail({
							message: res.msg,
							className: 'apiLoading'
						});
					}
				})
			},
			/*
			 *  查询支付方法
			 * */
			PayMethod(payTypeId) {
				let data = {
					companyId: this.roomData.companyId,
					payTypeId: payTypeId
				}
				reqPayMethod(data).then(res => {
					if (res.success) {
						this.Method = res.data
					} else {
						Toast.fail({
							message: res.msg,
							className: 'apiLoading'
						});
					}
				})
			},
			/*
			 * 确认付款 调下单接口并调用微信支付
			 * */
			confirmPayment() {
				let data = {
					userId: this.userId,
					roomId: this.roomId,
					methodId: this.Method.id
				}
				reqPayOrderAdd(data).then(res => {
					if (res.success) {
						this.onBridgeReady(res.data,false)
					} else {
						Toast.fail({
							message: res.msg,
							className: 'apiLoading'
						});
					}
				})
			},
			confirmPFPayment() {
				this.payTypes = 'pf';
				var usrChildFlg = this.$cookies.get('userInfo').openId;
				if(!usrChildFlg){
					var wxUserInfo = localStorage.getItem('wxUserInfo');
					if(!wxUserInfo){
						usrChildFlg =JSON.parse(wxUserInfo).openid
						if(!usrChildFlg){
							Toast.fail({
								message: '未获取到登录信息，请重新登录',
								className: 'apiLoading',
								onOpened:()=>{
									  this.$router.push({
										path:'/login',
										name:'login'
									  })
								}
							});
							return false
						}
					}else{
						Toast.fail({
							message: '未获取到登录信息，请重新登录',
							className: 'apiLoading',
							onOpened:()=>{
								  this.$router.push({
									path:'/login',
									name:'login'
								  })
							}
						});
						return false
					}
				}
				let data = {
					userId: this.userId,
					roomId: this.roomId,
					methodId: this.Method.id,
					usrChildFlg: usrChildFlg,
					subMechNoAcctID: envJS.app_id
				}
				reqPFPayOrderAdd(data).then(res => {
					if (res.success) {
						this.onBridgeReady(res.data,true)
					} else {
						Toast.fail({
							message: res.msg,
							className: 'apiLoading'
						});
					}
				})
				// Toast.fail({
				// 	message: '支付升级维护中！',
				// 	className: 'apiLoading'
				// });
				//this.orderSearch({},0);
				// this.orderClear();
			},
			/*
			 * 调微信支付的全局方法
			 * */
			onBridgeReady(data,isPf) {
				let _that = this;
				//调用浦发查询状态
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest', {
						"appId": data.resp.appId, //公众号名称，由商户传入
						"timeStamp": data.resp.timeStamp, //时间戳，自1970年以来的秒数
						"nonceStr": data.resp.nonceStr, //随机串
						"package": data.resp.package,
						"signType": data.resp.signType, //"MD5",         //微信签名方式：
						"paySign": data.resp.paySign //微信签名
					},
					function(res) {
						//this.errors =res.err_msg+"---";
						if (res.err_msg == "get_brand_wcpay_request:ok") {
							//支付成功
							// 使用以上方式判断前端返回,微信团队郑重提示：
							//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
							//正常支付
							_that.$router.push({
								path: '/payresult',
								name: 'payresult',
								query: {
									result: res.err_msg,
									roomId: _that.roomId,
									payData:JSON.stringify(data),
									payTypes:_that.payTypes
								}
							})

						}
						if (res.err_msg == "get_brand_wcpay_request:cancel") {
							//支付失敗
							// 使用以上方式判断前端返回,微信团队郑重提示：
							//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
							_that.$router.push({
								path: '/payresult',
								name: 'payresult',
								query: {
									result: res.err_msg,
									roomId: _that.roomId
								}
							})
						}
						if (res.err_msg == "get_brand_wcpay_request:fail") {
							//支付失敗
							// 使用以上方式判断前端返回,微信团队郑重提示：
							//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
							_that.$router.push({
								path: '/payresult',
								name: 'payresult',
								query: {
									result: res.err_msg,
									roomId: _that.roomId
								}
							})
						}
					});
					if(isPf){
						this.orderSearch(data, 0);
					}
			},
			//订单查询
			orderSearch(data, num) {
				var params = {
					roomId: this.roomId,
					tranOrdrNo: data.resp.tranOrdrNo,
					tranDate: data.resp.tranDate
				};
				reqPFSearch(params).then(res => {
					if (res.ordrSt == "00") {
						this.$router.push({
							path: '/payresult',
							name: 'payresult',
							query: {
								result: "get_brand_wcpay_request:ok",
								roomId: this.roomId,
								payData:JSON.stringify(data),
								payTypes:this.payTypes
							}
						})
					} else {
						if (num < 20) {
							num++
							this.timeout=setTimeout(() => {
								this.orderSearch(data, num);
							}, 3000);
						} else {
							this.$router.push({
								path: '/payresult',
								name: 'payresult',
								query: {
									result: 'get_brand_wcpay_request:exception',
									roomId: this.roomId,
									payData:JSON.stringify(data),
									payTypes:this.payTypes
								}
							})
						}

					}
				})
			},
			//清算测试
			orderClear() {
				reqPFClear({
					tranStrtDt: '20200812',
					orddDateEndDt: '20200813',
					companyId: "D4v1pQBEqaNlLe7wj9Ld9knJgZP5oARy83W"
				}).then(res => {
					console.log(res);
				})
			},
			stopHot(){
				const params = {
					companyId:this.roomData.companyId,
					userId:this.userId,
					roomId:this.roomId,
				}
				stopHot(params).then(res=>{
					if(res.success){
						this.roomData = res.data
					}
				})
			},
			recoverHot(){
				const params = {
					companyId:this.roomData.companyId,
					userId:this.userId,
					roomId:this.roomId,
				}
				recoverHot(params).then(res=>{
					if(res.success){
						this.roomData = res.data
					}
				})
			},
			valveRel(){
				const params = {
					roomId:this.roomId,
				}
				valveRel(params).then(res=>{
					this.showStop = res.data
				})
			},
      hideCenterName(name){
        let newStr;
        if (name.length === 2) {
          newStr = name.substr(0, 1) + '*';
        } else if (name.length > 2) {
          let char = '';
          for (let i = 0, len = name.length - 2; i < len; i++) {
            char += '*';
          }
          newStr = name.substr(0, 1) + char + name.substr(-1, 1);
        } else {
          newStr = name;
        }
        return newStr;
      }
		}
	}
</script>
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .contentPayDet
    padding 10px 0px
    .orange
      color #ff6d02
    .cardBar
      margin 16px 0px
      padding 24px 24px 40px
      background #fff
      .InfoCard
        background url("./images/bg.png") no-repeat center
        background-size 100% 100%
        padding 48px 30px 20px 40px
        color #fff
        .cardNumber
          line-height 40px
          font-size 38px
          span
            font-size 46px
            font-weight bold
        .name
          padding 15px 0px 40px
          font-size 30px
        .address
          font-size 26px
          padding 30px 0px 15px
        .area
          padding 15px 0px 40px
          font-size 30px
        .money
          line-height 40px
          border-top 2px dashed #fff /*no*/
          padding 27px 0px 20px
          font-size 28px
          span
            font-size 46px
            font-weight bold
    .billBar
      padding 0px 54px 40px 50px
      background #fff
      margin 7px 0px
      .title
        font-size 26px
        color #999999
        padding 42px 0px 36px
        border-bottom 2px solid #f0f0f0
        position relative
        .icon
          display inline-flex
          width 22px
          height 22px
          margin-right 12px
          background url("./images/time_icon.png") no-repeat center
          background-size 100% 100%
        .van-button
          position absolute
          right 0
          bottom 15px
          box-sizing content-box
          height 26px
          font-size 26px
          padding 10px 15px
          float right
      .cont
        font-size 28px
        color #888888
        .bill-money
          padding 34px 0px
    .barBtn
      padding 15% 40px 0px
      .btn
        color #ffffff
        font-size 32px
        background #ff6d02
        height 88px
        line-height 88px
    .noPayBar
      margin 10px 0px
      height 626px
      background #ffffff
      text-align center
      .noPayPC
        height 50%
        margin-top 15%
        background url("./images/unfound_5.png") no-repeat center
        background-size 50% auto
      .text1
        font-size 32px
        padding 20px 0px
      .text2
        font-size 24px
        color #aaaaaa
    .van-action-sheet__header
      height 88px
      font-size 30px
      line-height 80px
    .van-action-sheet__close
      font-size 40px
    .PayPop
      padding 70px 32px
      .money
        text-align center
        font-size 24px
        color #999999
        span
          display inline-flex
          font-size 80px
          padding 32px 0px
      .Ptext1
        height 80px
        line-height 80px
        font-size 32px
        color #222222
        border-bottom 1px solid #f0f0f0
      .Ptext2
        height 80px
        line-height 80px
        font-size 30px
        color #888888
        border-bottom 1px solid #f0f0f0
      .barBtn
        margin-top 100px
        padding 0px 40px
</style>



// WEBPACK FOOTER //
// src/pages/PayDetail/PayDetail.vue